// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__OFSni","author":"Table_author__1DKzS","authorImage":"Table_authorImage__gJEer","unreadRow":"Table_unreadRow__2ELVt"};